import React from 'react';
import './StyledInput.css';

const StyledDateInput = ({ value, onChange, label, placeholder, variant = 'default' }) => {
  return (
    <div className={`styled-input-wrapper ${variant}`}>
      <label className="styled-input-label">{label}</label>
      <div className="styled-input-container">
        <div className="styled-input-icon">📅</div>
        <input
          type="date"
          className="styled-input"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default StyledDateInput;

